<template lang="html">
  <svg xmlns="http://www.w3.org/2000/svg" height="480" width="640" viewBox="0 0 640 480">
    <g fill-rule="evenodd">
      <path fill="#fff" d="M640.006 479.994H0V0h640.006z"/>
      <path fill="#388d00" d="M640.006 479.994H0V319.996h640.006z"/>
      <path fill="#d43516" d="M640.006 160.127H0V.13h640.006z"/>
    </g>
  </svg>
</template>

<script>
// http://flag-icon-css.lip.is/
export default {
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/flags/hu.vue